import LocationSourceSystemRelate from '../api/LocationSourceSystemRelate';
import Site from '../api/Site';
import StatusCodes from 'node-modules-http-status-codes'; // if error run in terminal $npm install http-status-codes --save

export class SourceSystemValidationService {
  static connexionSapSourceTypeName = 'sap_location_code';
  static noValidationSourceSystems = [
    {
      sourceSystem: 'genetec',
      sourceSystemType: [
        'attendance_factor'
      ]
    },
    {
      sourceSystem: 'workplace insights',
      sourceSystemType: [
        'pi_ok',
        'wi_attendance'
      ]
    },
    {
      sourceSystem: 'gdw',
      sourceSystemType: [
        'gdw_l6',
        'gdw_l7'
      ]
    },
    {
      sourceSystem: 'grdb',
      sourceSystemType: [
        'all_location_code'
      ]
    }
  ];

  static async validateLocationSourceSystem(sourceSystemLink, countryId) {
    if (sourceSystemLink.sourceSystemIdTypeName === this.connexionSapSourceTypeName) {
      await LocationSourceSystemRelate.validateSourceSystemReferenceIdWithinCountry(
        sourceSystemLink.sourceSystemIdTypeId,
        sourceSystemLink.sourceSystemReferenceId,
        countryId
      ).then((apiRes) => this.handleValidationResponse(apiRes, sourceSystemLink));
    }
    else {
      await LocationSourceSystemRelate.validateSourceSystemReferenceId(
        sourceSystemLink.sourceSystemIdTypeId,
        sourceSystemLink.sourceSystemReferenceId
      ).then((apiRes) => this.handleValidationResponse(apiRes, sourceSystemLink));
    }

    return sourceSystemLink;
  }

  static async validateSiteSourceSystem(sourceSystemLink) {
    await Site.validateSourceSystemReferenceId(
      sourceSystemLink.sourceSystemIdTypeId,
      sourceSystemLink.sourceSystemReferenceId
    ).then((apiRes) => this.handleValidationResponse(apiRes, sourceSystemLink));

    return sourceSystemLink;
  }

  static handleValidationResponse(apiRes, sourceSystemLink) {
    if (apiRes) {
      if (apiRes.status == StatusCodes.NO_CONTENT) {
        sourceSystemLink.isSourceSystemValid = true;
      }
      else if (apiRes.status == StatusCodes.OK) {
        if (sourceSystemLink.sourceSystemReferenceId !== sourceSystemLink.originalSourceSystemReferenceId) {
          sourceSystemLink.isSourceSystemValid = false;
          sourceSystemLink.validationErrorMessage = 'Source System Reference ID already exists in UDM';
        } else {
          sourceSystemLink.isSourceSystemValid = true;
        }
      } else {
        sourceSystemLink.validationErrorMessage = 'Error: Contact your UDM Admin';
      }
    }

    sourceSystemLink.isLoading = false;
  }

  static isOriginalSourceSystem(eventValue, sourceSystem) {
    return (
      eventValue === sourceSystem.originalSourceSystemReferenceId
      && sourceSystem.sourceSystemIdTypeId === sourceSystem.originalSourceSystemIdTypeId
    )
  }

  static isNoValidationSourceSystem(sourceSystem) {
    return this.noValidationSourceSystems.some(system =>
      system.sourceSystem === sourceSystem.sourceSystemName.toLowerCase()
      && system.sourceSystemType.includes(sourceSystem.sourceSystemIdTypeName.toLowerCase())
    );
  }
}
